import Field from './Field';
import { SetInputFilter } from '../Util/FilterInput';
import { Store } from '../../../../redux/stores';
import { charactersActions } from '../../../../redux/actions';

export default class TextFloat extends Field {

    constructor() {
        super();
        this.type = 'TextFloat';
        this.maxSize = [32, 2];
        this.minSize = [1, 1];
    }
    
    create(target, options) {
        let container = document.createElement('div');
        let input = document.createElement('input');

        SetInputFilter(input, (value) => {
            return /^\d*[.,]?\d*$/.test(value);
        });

        input.internalType = 'TextFloat';
        if (options.onBlur) {
            let valueOnEnter = null;
            input.addEventListener('focus', () => {
                valueOnEnter = input.value;
            });
            input.addEventListener('blur', () => {
                input.value = input.value.replace(',','.');
                if (input.value !== valueOnEnter) {
                    options.onBlur();
                }
            });
        }

        input.setAttribute('name',`sheet-${this.name || this.nameId}`);

        if (this.props.auto) {
            input.setAttribute('readonly','readonly');
        }

        container.classList.add('sheet-container');
        input.classList.add('sheet-inputtext');

        let detailsBtn = document.createElement('div');
        detailsBtn.classList.add('sheet-open-details');
        detailsBtn.addEventListener('click', () => {
            Store.dispatch(charactersActions.setOpenedDetail(true, this.name || this.nameId))
        });

        this.elements = {container, input, detailsBtn};
        this.update(options);

        container.append(input);
        container.append(detailsBtn);

        target.append(container);
    }

    update(options) {
        this.elements.container.style.fontSize = `${options.unit}px`;
        this.elements.container.style.backgroundColor = options.highlight ? '#444' : 'transparent';
        this.elements.container.style.gridRowStart = 1 + this.y;
        this.elements.container.style.gridColumnStart = 1 + this.x;
        this.elements.container.style.gridRowEnd = (1 + this.y) + (this.height);
        this.elements.container.style.gridColumnEnd = (1 + this.x) + (this.width);

        this.elements.container.classList[options.selectedId === this.id ? 'add' : 'remove']('selected');

        //this.elements.input.style.height = `${options.unit * 2}px`;
        this.elements.input.style.fontSize = `${options.unit * 0.6667}px`;
        this.elements.input.style.textAlign = this.props.textAlign;
        this.elements.input.title = this.props.name || this.props.nameId;

        if (this.props.textSize) {
            this.elements.input.style.fontSize = (options.unit * 0.66667 * parseFloat(this.props.textSize)) + 'px';
        }

        this.elements.detailsBtn.style.display = this.props.hasDetails ? 'flex' : 'none';
    }

    set(value) {
        this.elements.input.value = value;
    }

    get() {
        return this.elements.input.value;
    }

    clean() {
        this.elements.input.value = '';
    }

    error() {
        this.elements.input.classList.add('error');
    }

    fix() {
        this.elements.input.classList.remove('error');
    }

}